import { render } from "./AccountDeactivationNotice.vue?vue&type=template&id=41181d18&scoped=true"
import script from "./AccountDeactivationNotice.vue?vue&type=script&lang=js"
export * from "./AccountDeactivationNotice.vue?vue&type=script&lang=js"

import "./AccountDeactivationNotice.vue?vue&type=style&index=0&id=41181d18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41181d18"]])

export default __exports__